import React, { useEffect, useState } from "react";
import "./Account.css";
import Account_banner_holder from "./account_banner_holder/Account_banner_holder";
import Account_tab from "./account_tabs/Account_tab";
import { UserGet, UserWalletHistory } from "../../utils/apis/myAccount/myAccount";
import { PointSetup } from "../../utils/apis/master/Master";

function Account() {
  const [user, setUser] = useState();
  const getUserData = async () => {
    const res = await UserGet();
    if (res?.success) {
      setUser(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  const [WalletHistory, setWalletHistory] = useState();
  const getUserWalletHistory = async () => {
    const res = await UserWalletHistory();
    if (res?.success) {
      setWalletHistory(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  const [pointSetup, setPointSetup] = useState();
  const getPointsetup = async () => {
    const res = await PointSetup();
    if (res?.success) {
      setPointSetup(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  useEffect(() => {
    getPointsetup();
    getUserData();
    getUserWalletHistory();
  }, []);
  return (
    <>
      <section className="account_section">
        <Account_banner_holder user={user} pointSetup={pointSetup} WalletHistory={WalletHistory} />

        <Account_tab />
      </section>
    </>
  );
}

export default Account;
